export interface NotificationRedirectPage {
  value: string;
  label: string;
  encryptId: boolean;
}

export const NOTIFICATION_REDIRECT_PAGES: NotificationRedirectPage[] = [
  {
    value: '/partners/drop-details/{id_dossier_drop}',
    label: 'Fiche détail dossier',
    encryptId: true
  },
  {
    value: '/fiche-projet/{guid_projet}',
    label: 'Fiche détail projet (après travaux)',
    encryptId: false
  },
  {
    value: '/fiche-projet-avant-travaux/{guid_projet}',
    label: 'Fiche détail projet (avant travaux)',
    encryptId: false
  }
];
